import { createSelector } from '@reduxjs/toolkit';
import { selectOffersData } from './selectOffersData';
import { selectOffersStatus } from './selectOffersStatus';
import { EOffersStatus } from 'shared/types/offers';

export const selectAllOffersLink = createSelector(
  [selectOffersData, selectOffersStatus],
  ({ allOffersLink }, status) => (status === EOffersStatus.Ready ? allOffersLink : undefined),
);
